import licenseTypes from 'data/LicenseTypes/licenseTypes';
import { states as retailerStates } from './retailerStates';
import { groups as reciprocalStates } from './reciprocalStates';

export default function getAvailableLicenses(homeState, isProducer) {
  // Get both linceses required and not required.
  const licenses = licenseTypes.licenses || [];
  const statesWithDifferentBehavior = ['AK'];

  if (isProducer) {
    return licenses;
  }

  // Contains all license types for retailer states
  const retailStateList = retailerStates
  .map(s => licenses.find(lic => lic.StateCode === s.code))
  .map((lic) =>{
    if (statesWithDifferentBehavior.includes(lic.StateCode)) {
      return { ...lic, LicenseName: 'No License Required', NoLicenseRequired: true };
    }
    return lic;
  });
  
  let reciprocalStateList = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const group of reciprocalStates) {
    if (group.includes(homeState)) {
      const mappedGroup = group
        .map(stateCode => licenses.find(lic => lic.StateCode === stateCode))
        .map((lic) => {
          if (lic.StateCode !== homeState) {
            return { ...lic, LicenseName: 'No License Required', NoLicenseRequired: true };
          }
          return lic;
        });
      reciprocalStateList = [...reciprocalStateList, ...mappedGroup];
    }
  }

  return [...retailStateList, ...reciprocalStateList];
}
